import React from 'react';
import ImageGallery from '../components/ImageGallery';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ContactModal from '../components/ContactModal';
import GalleryStats from '../components/GalleryStats';



const Gallery = () => {
   const [isContactModalOpen, setIsContactModalOpen] = React.useState(false);
    const openContactModal = () => setIsContactModalOpen(true);
  const closeContactModal = () => setIsContactModalOpen(false);
  return (
    <div className="gallery-page min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
       <Header openContactModal={openContactModal} />
         {/* Modal de contact */}
      <ContactModal 
        isOpen={isContactModalOpen} 
        onClose={closeContactModal} 
      />
      {/* En-tête de la page */}
      <div className="bg-gradient-to-r from-fsf-primary to-fsf-secondary py-16">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Galerie FSF
          </h1>
          <p className="text-xl text-white/90 max-w-2xl mx-auto text-justify">
            Découvrez les moments précieux de notre communauté : mariages, pèlerinages, 
            événements culturels et activités communautaires.
          </p>
        </div>
      </div>
      
      {/* Section Statistiques */}
      <GalleryStats />
      
      {/* Section Galerie */}
      <section className="py-8">
        <ImageGallery />
      </section>
      <Footer />
    </div>
  );
};

export default Gallery;